export default "__VITE_ASSET__7pER2zFN__"